import React, { Fragment } from 'react';
import {
  List,
  Edit,
  Create,
  Datagrid,
  FunctionField,
  TextField,
  BooleanField,
  EditButton,
  DisabledInput,
  SelectInput,
  SimpleForm,
  BooleanInput,
  TextInput,
  ImageField,
  CardActions,
  ListButton,
} from 'react-admin';
import Button from '@material-ui/core/Button';
import CheckBox from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlank';

import BulkUpdateButton from './ui/BulkUpdateButton';
import BulkDeleteButton from './ui/BulkDeleteButton';
import PolarityField from './ui/PolarityField';
import ListFilter from './ui/ListFilter';
import TwitterTimeline from './ui/TwitterTimeline';
import tags from '../config/tags';

const TwitterUserBulkActionButtons = props => (
  <Fragment>
      <BulkUpdateButton {...props} field='active' value={true} label='Activate' icon={<CheckBox />} color='primary' />
      <BulkUpdateButton {...props} field='active' value={false} label='Deactivate' icon={<CheckBoxOutlineBlank />} color='secondary' />
      <BulkDeleteButton {...props} />
  </Fragment>
);

const TwitterUserActions = ({ basePath, data, resource }) => (
  <CardActions>
      {data && 
        <Button style={{marginRight: '10px'}} variant="outlined" color="primary" href={'https://twitter.com/' + data.screen_name} target="_blank" rel="noopener noreferrer">
          Link
        </Button>}
      <ListButton basePath={basePath} variant="outlined" style={{marginRight: '10px', padding: '7px 16px'}} />
  </CardActions>
);

export const TwitterUserList = props => (
  <List title="Twitter Users" {...props} bulkActionButtons={<TwitterUserBulkActionButtons />} filters={<ListFilter />} perPage={100}>
    <Datagrid>
      <ImageField source="profile_image" title="Profile image" />
      <FunctionField
        source="screen_name"
        label="Screen Name"
        render={(record, source) => (
          <a href={'https://twitter.com/' + record[source]} target="_blank" rel="noopener noreferrer">
            {record[source]}
          </a>
        )}
      />
      <TextField source="name" />
      <TextField label="Tweets" source="activities.statuses" />
      <TextField label="Tweets (60 days)" source="activities.statuses60d" />
      <TextField label="Followers" source="activities.followers" />
      <TextField label="Favorites" source="activities.favorites" />
      <TextField label="Listed" source="activities.listed" />
      <PolarityField label="Polarity" source="tag" />
      <BooleanField source="active" />
      <EditButton label="" />
    </Datagrid>
  </List>
);

const SiteName = ({ record }) => {
  return <span>Twitter User {record ? `"${record.name}"` : ''}</span>;
};

export const TwitterUserEdit = props => (
  <div>
    <Edit title={<SiteName />} actions={<TwitterUserActions />} {...props}>
      <SimpleForm>
        <DisabledInput source="id" />
        <TextInput source="name" />
        <TextInput source="screen_name" />
        <TextField label="followers" source="activities.followers" />
        <TextField label="Statuses" source="activities.statuses" />
        <SelectInput source="tag.ref" label="Polarity" allowEmpty={true} choices={tags} optionValue="ref" />
        <BooleanInput source="active" />
      </SimpleForm>
    </Edit><br /><br />
    <TwitterTimeline {...props} />
  </div>
);

export const TwitterUserCreate = props => (
  <Create title="New Twitter User" actions={<TwitterUserActions />} {...props}>
    <SimpleForm>
      <TextInput source="screen_name" />
      <SelectInput source="tag.ref" label="Polarity" allowEmpty={true} choices={tags} optionValue="ref" />
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/resources/twitterusers.js